import { useEffect, useRef } from 'react';
import { Reveal, SectionLabel, SunMark } from './Common';
import { InstagramBrand, FacebookBrand, TikTokBrand, YouTubeBrand } from './SocialIcons';
import { socialLinks } from '../contactData';
import { elfsightAppId } from '../socialData';
import '../styles/social.css';

const ELFSIGHT_SRC = 'https://elfsightcdn.com/platform.js';

const followButtons = [
  { id: 'instagram', Icon: InstagramBrand, label: 'Seguici su Instagram', variant: 'button-gold' },
  { id: 'facebook', Icon: FacebookBrand, label: 'Seguici su Facebook', variant: 'button-dark' },
  { id: 'tiktok', Icon: TikTokBrand, label: 'Seguici su TikTok', variant: 'button-dark' },
  { id: 'youtube', Icon: YouTubeBrand, label: 'Guarda su YouTube', variant: 'button-dark' },
];

const loadElfsightPlatform = () => {
  if (document.querySelector(`script[src="${ELFSIGHT_SRC}"]`)) return;
  const script = document.createElement('script');
  script.src = ELFSIGHT_SRC;
  script.async = true;
  script.setAttribute('data-use-service-core', '');
  document.body.appendChild(script);
};

export const SocialWall = () => {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node || !elfsightAppId) return;
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        loadElfsightPlatform();
        observer.disconnect();
      }
    }, { rootMargin: '250px' });
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return <section id="social" className="social-section section-pad" data-testid="social-section" ref={ref}>
    <SectionLabel id="social" number="06">RESTIAMO IN CONTATTO, OGNI GIORNO</SectionLabel>
    <div className="section-heading-row">
      <Reveal><h2 className="display-heading" data-testid="social-title">La follia continua.<br /><em>Seguici.</em></h2></Reveal>
      <Reveal className="social-heading-aside">
        <p data-testid="social-intro">I nostri ultimi post da Instagram e Facebook, in un unico muro.<br />Seguici su tutti i nostri canali e non perderti nulla.</p>
        <div className="social-follow-buttons">
          {followButtons.map(({ id, Icon, label, variant }) => {
            const link = socialLinks.find(social => social.id === id);
            if (!link) return null;
            return <a key={id} className={`button ${variant}`} href={link.url} target="_blank" rel="noopener noreferrer" data-testid={`social-follow-${id}`}><Icon size={20} /> {label}</a>;
          })}
        </div>
      </Reveal>
    </div>
    <Reveal className="social-wall-wrap" delay={0.1}>
      {elfsightAppId
        ? <div className={`elfsight-app-${elfsightAppId}`} data-elfsight-app-lazy data-testid="social-feed-widget" />
        : <div className="social-feed-placeholder" data-testid="social-feed-placeholder">
            <SunMark className="social-placeholder-star" />
            <p>Il muro con i post di Instagram e Facebook comparirà qui non appena l’associazione collegherà i propri account. Nel frattempo, seguici con i pulsanti qui sopra.</p>
          </div>}
    </Reveal>
  </section>;
};
